/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://gkzqamc2jvcwrm7rib5bhxu35i.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-zl23ejvdovchpl7tsjvxucfqli",
    "aws_cognito_identity_pool_id": "us-east-1:206814ef-0df7-40e4-9e5d-dbfe3434ad60",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_ayJublRzH",
    "aws_user_pools_web_client_id": "3sgpvpdarbggc8j85ljgcls1c8",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "rpp4ed76a38de9241f09e836c2cf6c70f49181137-prod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
